import React, {useState,useEffect} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import Select,{createFilter} from 'react-select'
import {envAwarePost,dateToAPIStandard,getRoundedDate,envAwareFormSubmit} from '../../util/util'
import useS3DirectUpload from '../../hooks/useS3DirectUpload'
import {
	newMessageScheduled,
	selectScheduledMessageById
} from '../../state/messengerSlice'
import useApiStatusEnvAwareFormSubmit from '../../hooks/useApiStatusEnvAwareFormSubmit'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import InputGroup from 'react-bootstrap/InputGroup'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import moment from 'moment'
import MemoRecorder from '../MemoRecorder/MemoRecorder'
import FileButton from '../FileButton/FileButton'
import {toggleShow as toggleShowMemoRecorder} from '../MemoRecorder/slice'
import isImage from 'is-image'
import useCurrentUser from '../../hooks/useCurrentUser'

const mapItemsToSelectObjects = (items,type) => items.map( item =>({
	label:type === 'tag' ? item.name : item.user_name,
	value:type === 'tag' ? item.id : item.user_id_number
}))//end map

const mapUsersToId = users => users.map(user=>user.user_id_number)

const MessageEditor = ({clients,trainers=[],tags}) => {
	const dispatch = useDispatch()
	const statusFormSubmit = useApiStatusEnvAwareFormSubmit()
	const [scheduling,setScheduling] = useState(false)

	const user = useCurrentUser()
	const isGym = user.account_type === 'gym'
	
	const [messageSaved,setMessageSaved] = useState(false)
	const [specifyByTag,setSpecifyByTag] = useState(false)
	const [matchExactly,setMatchExactly] = useState(false)
	const [status,setStatus] = useState('idle')
	const [recipientSpecification,setRecipientSpecification] = useState([])
	const [message,setMessage] = useState('')
	const [messageAll,setMessageAll] = useState(false)
	const [messageAllClients,setMessageAllClients] = useState(false)
	const [messageAllTrainers,setMessageAllTrainers] = useState(false)
	//get date rounded up 15 minutes
	const [startDate,setStartDate] = useState(getRoundedDate(15))
	const [endDate,setEndDate] = useState(getRoundedDate(15))
	const [repeat,setRepeat] = useState('none')
	const [interval,setInterval] = useState(1)
	const [weekDays,setWeekDays] = useState([])
	const [isRecurring,setIsRecurring] = useState(false)

	//memo related state
	const [isMemo,setIsMemo] = useState(false)
	const [memo,setMemo] = useState(null)
	const [memoType,setMemoType] = useState(null)

	const {
		file:attachment,
		processUpload,
		setUpload,
		clearUpload
	} = useS3DirectUpload()

	console.log(recipientSpecification)

	const saveHandler = async () => {
		setStatus('loading')
		const postData = {
			action:'scheduleMessage',
			message,
			schedule:{
				//for backend purposes daily is used for 
				//single occurance events 
				freq:repeat==='none'?'daily':repeat,
				//non-repeating or single weekly repeates can only 
				//have interval = 1
				interval:repeat==='none'||repeat==='weekly'?1:interval,
				start:dateToAPIStandard(startDate),
				end:isRecurring?'forever':dateToAPIStandard(endDate),
				week_days:weekDays,
				is_recurring:repeat==='none'?0:Number(isRecurring)
			}
		}
		if(Boolean(isMemo)){
			postData.is_memo = 1
			postData.memo = memo
			postData.transcode_memo_to_mp4 = 1
			postData.media_type_id = memoType === 'video' ?  1 : 4
		}
		if(Boolean(attachment)){
			const uploadRes = await processUpload()
			if(uploadRes.success) postData.attachment = uploadRes.payload.url
		}
		if (messageAll&&!specifyByTag) {
			//only all trainers
			if(messageAllTrainers&&!messageAllClients){
				postData.specification_id = 5
			} 
			//all trainers and all clients
			else if(messageAllClients&&messageAllTrainers){
				postData.specification_id = 6
			} 
			//only all clients
			else {
				postData.specification_id = 3
			}
		}else{
			if(specifyByTag){
				if(matchExactly){
					postData.specification_id = 2
				}else {
					postData.specification_id = 4
				}
				postData.tag_ids = recipientSpecification.map(s=>s.value)
			}else{
				postData.specification_id = 1
				postData.recipients = recipientSpecification.map(s=>s.value)
			}
		}
		statusFormSubmit('api/messaging/api/',postData,'message','save')
		.then(res=>{
			setStatus('idle')
			setMessage('')
			setScheduling(false)
			setMessageAll(false)
			setMessageAllClients(false)
			setMessageAllTrainers(false)
			setMatchExactly(false)
			setRecipientSpecification([])
			handleClearAttachment()
			resetScheduling()
			if (res.success === '1') setMessageSaved(true)
			if (res.success === '1') dispatch(newMessageScheduled(res.data))
		})
	}

	const sendHandler = async ()=>{
		setStatus('loading')

		let specification_id = 1
		if (messageAll&&!specifyByTag) {
			//only all trainers
			if(messageAllTrainers&&!messageAllClients){
				specification_id = 5
			} 
			//all trainers and all clients
			else if(messageAllClients&&messageAllTrainers){
				specification_id = 6
			} 
			//only all clients
			else {
				specification_id = 3
			}
		} else if(specifyByTag) {
			if(matchExactly){
				specification_id = 2
			}else{
				specification_id = 4
			}
		} else {
			specification_id = 1
		}

		const postData = { 
			action:'broadcastPrivateMessage',
			specification_id,
			message
		}

		if(Boolean(isMemo)){
			postData.is_memo = 1
			postData.memo = memo
			postData.transcode_memo_to_mp4 = 1
			postData.media_type_id = memoType === 'video' ?  1 : 4
		}

		if(Boolean(attachment)){
			const uploadRes = await processUpload()
			if(uploadRes.success) postData.attachment = uploadRes.payload.url
		}

		if(specifyByTag){
			postData.tag_ids = recipientSpecification.map(s=>s.value)
		}else{
			postData.recipients = recipientSpecification.map(s=>s.value)
		}


		envAwareFormSubmit({
			path:'api/messaging/api/',
			payload:postData
		}).then(res=>{
			setStatus('idle')
			setMessage('')
			resetScheduling()
			setRecipientSpecification([])
			setMessageAll(false)
			setMessageAllClients(false)
			setMessageAllTrainers(false)
			setMatchExactly(false)
			handleClearAttachment()
		})
	}

	const resetScheduling = ()=>{
		setRepeat('none')
		setWeekDays([])
		setInterval(1)
		setIsRecurring(false)
		setStartDate(getRoundedDate(15))
	}

	const handleToggleMemoRecorder = ()=>{
		dispatch(toggleShowMemoRecorder())
	}

	const handleClearAttachment = ()=>{
		clearUpload()
		setIsMemo(false)
		setMemo(null)
		setMemoType(null)
	}

	const handleFileSelect = e => {
		//clear existing attachment data
		handleClearAttachment()
		//set new upload
		setUpload(e.target.files[0])
	}

	const handleFinishMemo =  memoData => {
		setIsMemo(true)
		setMemo(memoData.memo)
		setMemoType(memoData.type)
	}

	//helper function for adding/removing a day from the 
	//array of repeat weekdays
	const toggleWeeklyDayString = (day) => {
		if (weekDays.includes(day)) {
			setWeekDays(weekDays.filter(d => d !== day))
		} else {
			setWeekDays([...weekDays, day])
		}
	}

	const selectOptions = (
		specifyByTag 
		? mapItemsToSelectObjects(tags,'tag') 
		: (
			trainers.length > 0 
			? [
				{
					label:'Trainers',
					options:mapItemsToSelectObjects(trainers,'user') 
				},
				{
					label:'Clients',
					options:mapItemsToSelectObjects(clients,'user') 
				},
			]
			:mapItemsToSelectObjects(clients,'user') 
		)
	)

	return (
		<div>
			<MemoRecorder handleFinish={handleFinishMemo}/>
			<div className="mb-2">
				<div className="d-flex justify-content-between mb-2">
					<small>Search clients/tags or select all</small>
					<div className="d-flex align-items-center" style={{fontSize:'14px'}}>
						<span className="mr-2">specify recipients by:</span>
						<label className="m-0 mr-2">
							<input 
								name="create_specification" 
								type="radio"
								onChange={()=>setSpecifyByTag(false)}
								checked={!specifyByTag}
							/> Name
						</label>
						<label className="m-0">
							<input 
								name="create_specification" 
								type="radio"
								onChange={()=>setSpecifyByTag(true)}
								checked={specifyByTag}
							/> Tag
						</label>
					</div>
				</div>
				<div className="d-flex cancelDrag">
					<Select
						filterOption={createFilter({ matchFrom: "start" })}
						className="w-100"
						isDisabled={messageAll}
						isMulti
						value={messageAll?[]:recipientSpecification}
						options={selectOptions}
						onChange={(selectedClients)=>{
							//to prevent toggling to all selecting all from 
							if(!messageAll){
								setRecipientSpecification(selectedClients)
							}
						}}
						noOptionsMessage={()=>(
							messageAll?'Sending to all':'Select...'
						)}
						/>
					{!specifyByTag&&
						<OverlayTrigger
							placement="left"
							overlay={
								<Tooltip>
									Send to all clients
								</Tooltip>
							}
						>
							<Button
								variant={messageAll?"primary":"outline-secondary"}
								className="ml-2"
								onClick={()=>{
									setMessageAll(!messageAll)
									setMessageAllClients(!messageAll)
									setMessageAllTrainers(false)
								}}>
								All
							</Button>
						</OverlayTrigger>
					}
				</div>
				{(messageAll&&!specifyByTag&&isGym)&&
					<div className="d-flex justify-content-around pt-2">
						<Form.Check 
							onChange={e=>{
								setMessageAllClients(e.target.checked)
							}}
							checked={messageAllClients}
							id="all-clients-check"
							label="All Clients"
						/>
						<Form.Check 
							onChange={e=>{
								setMessageAllTrainers(e.target.checked)
							}}
							checked={messageAllTrainers}
							id="all-trainers-check"
							label="All Trainers"
						/>
					</div>
				}
				{specifyByTag&&
					<Form.Check
						className="mt-1"
						checked={matchExactly}
						id="exact-tag-match-toggle"
						label="Only include clients that have ALL of the selected tags"
						onChange={e=>{setMatchExactly(e.target.checked)}}
					/>
				}
			</div>
			<Form.Control 
				as="textarea"
				value={message}
				style={{whiteSpace:'pre-wrap'} }
				name="messageText"
				id="messageText"
				onChange={e=>setMessage(e.target.value)}
				placeholder="Write a message"
			/>
			<div className="d-flex">
				{/* Regular image attachments selected from file browsers*/}
				{(Boolean(attachment))&&
					<>
						<img 
							src={URL.createObjectURL(attachment)}
							style={{
								maxWidth:'120px',
								maxHeight:'120px',
								objectFit:'scales',
								borderRadius:'8px',
								margin:'4px 4px 0 0'
							}} 
						/>
						<div>
						<small className="d-block">{attachment.name}</small>
							<Button onClick={handleClearAttachment} variant="outline-danger" size="sm">
								Remove
							</Button>
						</div>
					</>
				}
				{/* Memo attachments recorder from memo recorder*/}
				{(isMemo&&Boolean(memo))&&
					<>
						<video
							src={URL.createObjectURL(memo)}
							style={{
								maxWidth:'120px',
								maxHeight:'120px',
								objectFit:'scales',
								borderRadius:'8px',
								margin:'4px 4px 0 0'
							}} 
							controls 
						/>	
						<div>
							<small className="d-block">{memo.name}</small>
							<Button onClick={handleClearAttachment} variant="outline-danger" size="sm">
								Remove
							</Button>
						</div>
					</>
				}
			</div>
			<div className="d-flex justify-content-end mt-2">
				<OverlayTrigger overlay={
					<Tooltip>Add attachment</Tooltip>
				}>
					<FileButton 
						onChange={handleFileSelect} 
						className="mr-auto"
					/>
				</OverlayTrigger>
				<OverlayTrigger overlay={
					<Tooltip>
						Record a voice/video memo
					</Tooltip>
				}>
					<Button 
						className="text-dark"
						onClick={handleToggleMemoRecorder}
						disabled={status ===  'loading'} 
						variant="link"
					>
						<i className="fa fa-microphone"/> / <i className="fa fa-video"/>
					</Button>
				</OverlayTrigger>
				{!scheduling&&
					<OverlayTrigger overlay={<Tooltip>Schedule</Tooltip>}>
						<Button 
							className="text-primary"
							onClick={()=>setScheduling(!scheduling)}
							disabled={status ===  'loading'} 
							variant="link"
						>
							<i className="fas fa-calendar"/>
						</Button>
					</OverlayTrigger>
				}
				{!scheduling&&
					<Button
						variant="link"
						className="ml-2 text-success"
						disabled={
							status === 'loading' ||
							(!message&&!attachment) ||
							(!recipientSpecification.length && !messageAll)
						}
						onClick={sendHandler}>
						{
							status ===  'idle' ?
							<i className="fas fa-paper-plane"/>
							:
							<Spinner animation="border" role="status" size="sm">
								<span className="sr-only">Loading...</span>
							</Spinner>
						}
					</Button>
				}
			</div>
			{
				scheduling&&
				<div>
					<Form.Control 
						onChange={e=>{
							const val = e.target.value
							setRepeat(val)
							if(val==='none'){
								setIsRecurring(false)
								setEndDate(startDate)
							}
						}}
						value={repeat} 
						as="select" 
						custom
					>
						<option value="none">No Repeat</option>
						<option value="daily">Daily</option>
						<option value="weekly">Weekly</option>
					</Form.Control>
					{repeat==='daily'&&
						<div>
							<small>Repeat every</small>
							<InputGroup>
								<Form.Control 
									onChange={e=>{
										setInterval(e.target.value)
									}}
									value={interval}
									placeholder="number of days"
								/>
								<InputGroup.Append>
									<InputGroup.Text id="basic-addon2">days</InputGroup.Text>
								</InputGroup.Append>
							</InputGroup>
						</div>
					}
					{repeat==='weekly'&&
						<div className="d-flex justify-content-around mt-1">
							{['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(d => (
								<Form.Check
									checked={weekDays.includes(d.toLowerCase())}
									onChange={()=>{
										toggleWeeklyDayString(d.toLowerCase())
									}}
									id={`weekly-${d}`}
									label={d}
								/>
							))}
						</div>
					}
					<div className='mt-2'>
						<div className="d-flex justify-content-between flex-wrap">
							<div>
								{repeat!=='none'&&
									<small className="d-block">Start Date</small>
								}
								<DatePicker
									onChangeRaw={e=>{e.preventDefault()}}
									selected={startDate}
									onChange={date=>{
										setStartDate(date)
										if (repeat==='none') setEndDate(date)
									}}
									showTimeSelect
									timeIntervals={15}
									dateFormat="MMM d, yy @ h:mm aa"
									minDate={new Date()}
									popperModifiers={{
										preventOverflow: {
											enabled: true,
											escapeWithReference: false,
											boundariesElement: 'viewport'
										}
									}}
									popperProps={{
										positionFixed: true
									}}
									customInput={<Form.Control/>}
								/>
								{repeat!=='none'&&
									<Form.Check 
										onChange={e=>{
											setIsRecurring(e.target.checked)
										}}
										className="mt-1"
										id="no-end-date-check"
										checked={isRecurring}
										label="No End Date"
									/>
								}
							</div>
							{(repeat!=='none'&&!isRecurring)&&
								<div>
									<small className="d-block">End Date</small>
									<DatePicker
										onChangeRaw={e=>{e.preventDefault()}}
										selected={endDate}
										onChange={date=>setEndDate(date)}
										dateFormat="MMM d, yyyy"
										minDate={startDate}
										popperModifiers={{
											preventOverflow: {
												enabled: true,
												escapeWithReference: false,
												boundariesElement: 'viewport'
											}
										}}
										popperProps={{
											positionFixed: true
										}}
										customInput={<Form.Control/>}
									/>
								</div>
							}
						</div>
					</div>
					<hr className="my-1"/>
					<div className="text-right">
						<OverlayTrigger overlay={
							<Tooltip>Cancel Scheduling</Tooltip>
						}>
							<Button 
								className="text-danger"
								onClick={()=>setScheduling(!scheduling)}
								disabled={status ===  'loading'} 
								variant="link"
							>
								<i className="fa fa-times"/>
							</Button>
						</OverlayTrigger>
						<Button
							variant="link"
							className="ml-2 text-info"
							disabled={
								status === 'loading' ||
								(!message&&!attachment) ||
								(!recipientSpecification.length && !messageAll)
							}
							onClick={saveHandler}>
							{
								status ===  'idle' ?
								<i className="fas fa-save"/>
								:
								<Spinner animation="border" role="status" size="sm">
									<span className="sr-only">Loading...</span>
								</Spinner>
							}
						</Button>
					</div>
				</div>
			}
			{(messageSaved)? <p style={{color:"green", "text-align":"right"}}>Message Saved</p>:null}
			{scheduling&&
				<div className="text-right mt-1">
					<small>Can only be scheduled on 15 minute intervals <i className="fa fa-info-circle"/> </small>
				</div>
			}
		</div>
	)
}

export default MessageEditor